<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
/* 默认样式 */
body,div,ul,li,span,img,input,form{ margin:0; padding:0; }
body,p,h1,h2,h3,h4,h5,h6,ul,ol,dl,li,dd{ margin:0; }
ul,ol,{ padding:0; }
p{ word-wrap:break-word; word-break:normal; }   /*自动换行*/
body{ font-family:"冬青黑体简体中文","微软雅黑","宋体",Arial,sans-serif; height:100%; }
a{ text-decoration:none; }
li{ list-style:none; }
img{ border:none 0; }
input{ outline:none; border:none; background:none; }
input,textarea,select{ margin:0; }					
input,textarea{ padding:0; }
input::-ms-clear{display:none; }
/* 浮动公共样式 */
.fl{ float:left; _display:inline; }
.fr{ float:right; _display:inline; }
.clearfix:after{ display:block; content:''; clear:both; }
.clear{ zoom:1; }
/*公共样式*/

#app{ height:100%; }
.page{ padding-top:30px; }

/*表格补充样式*/
.ivu-table-header table,.ivu-table-body table{ width:100%; }


/*element-ui 兼容iview的样式*/
.ivu-form-item-error .el-input__inner{ border:1px solid #ed3f14; }

/*loading z-index*/
body .ivu-spin-fix{ z-index:10000; }
body .ivu-modal-wrap{ z-index:10000; }

/*模板答案设置图片样式*/
.demo-upload-list{
    display: inline-block;
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    border: 1px solid transparent;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
}
.demo-upload-list img{
    width: 100%;
    height: 100%;
}
.demo-upload-list-cover{
    display: none;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
}
.demo-upload-list:hover .demo-upload-list-cover{
    display: block;
}
.demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue